export interface Country {
  code: string;
  en: string;
  ar: string;
}

// Saudi Arabia first (default), then alphabetical
export const COUNTRIES: Country[] = [
  { code: "SA", en: "Saudi Arabia", ar: "المملكة العربية السعودية" },
  { code: "AE", en: "United Arab Emirates", ar: "الإمارات العربية المتحدة" },
  { code: "BH", en: "Bahrain", ar: "البحرين" },
  { code: "KW", en: "Kuwait", ar: "الكويت" },
  { code: "OM", en: "Oman", ar: "عُمان" },
  { code: "QA", en: "Qatar", ar: "قطر" },
  { code: "YE", en: "Yemen", ar: "اليمن" },
  { code: "EG", en: "Egypt", ar: "مصر" },
  { code: "JO", en: "Jordan", ar: "الأردن" },
  { code: "LB", en: "Lebanon", ar: "لبنان" },
  { code: "SY", en: "Syria", ar: "سوريا" },
  { code: "IQ", en: "Iraq", ar: "العراق" },
  { code: "PS", en: "Palestine", ar: "فلسطين" },
  { code: "MA", en: "Morocco", ar: "المغرب" },
  { code: "DZ", en: "Algeria", ar: "الجزائر" },
  { code: "TN", en: "Tunisia", ar: "تونس" },
  { code: "LY", en: "Libya", ar: "ليبيا" },
  { code: "SD", en: "Sudan", ar: "السودان" },
  { code: "TR", en: "Turkey", ar: "تركيا" },
  { code: "PK", en: "Pakistan", ar: "باكستان" },
  { code: "IN", en: "India", ar: "الهند" },
  { code: "BD", en: "Bangladesh", ar: "بنغلاديش" },
  { code: "PH", en: "Philippines", ar: "الفلبين" },
  { code: "ID", en: "Indonesia", ar: "إندونيسيا" },
  { code: "MY", en: "Malaysia", ar: "ماليزيا" },
  { code: "GB", en: "United Kingdom", ar: "المملكة المتحدة" },
  { code: "US", en: "United States", ar: "الولايات المتحدة" },
  { code: "CA", en: "Canada", ar: "كندا" },
  { code: "FR", en: "France", ar: "فرنسا" },
  { code: "DE", en: "Germany", ar: "ألمانيا" },
  { code: "IT", en: "Italy", ar: "إيطاليا" },
  { code: "ES", en: "Spain", ar: "إسبانيا" },
  { code: "NL", en: "Netherlands", ar: "هولندا" },
  { code: "CH", en: "Switzerland", ar: "سويسرا" },
  { code: "SE", en: "Sweden", ar: "السويد" },
  { code: "NO", en: "Norway", ar: "النرويج" },
  { code: "AU", en: "Australia", ar: "أستراليا" },
  { code: "NZ", en: "New Zealand", ar: "نيوزيلندا" },
  { code: "JP", en: "Japan", ar: "اليابان" },
  { code: "KR", en: "South Korea", ar: "كوريا الجنوبية" },
  { code: "CN", en: "China", ar: "الصين" },
  { code: "ZA", en: "South Africa", ar: "جنوب أفريقيا" },
  { code: "NG", en: "Nigeria", ar: "نيجيريا" },
  { code: "KE", en: "Kenya", ar: "كينيا" },
  { code: "ET", en: "Ethiopia", ar: "إثيوبيا" },
  { code: "OTHER", en: "Other", ar: "أخرى" },
];
